import React from 'react'
import { router } from '@inertiajs/react'

export default function AccountSwitcher({
  account,
  accounts,
  baseUrl = window.location.pathname,
  className = ''
}) {
  if (!accounts || accounts.length <= 1) {
    return <span className={`text-sm text-gray-600 ${className}`}>{account.name}</span>
  }

  const handleChange = (e) => {
    const url = new URL(baseUrl, window.location.origin)
    url.searchParams.set('account_id', e.target.value)
    router.visit(url.pathname + url.search)
  }

  return (
    <select
      value={account.id}
      onChange={handleChange}
      className={`text-sm bg-transparent border border-gray-300 rounded-md px-2 py-1 cursor-pointer hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-sky-500 ${className}`}
    >
      {accounts.map(a => (
        <option key={a.id} value={a.id}>{a.name}</option>
      ))}
    </select>
  )
}
